/**
 * Composant parent de MyOpen
 */
import "./index.css";
import App from "./containers/App";
import { BrowserRouter } from "react-router-dom";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import { publicRoutes, privateRoutes } from "./myOpenRoutes";
import store from "./store/myOpenStore";
import MenuAppBar from "./components/MenuAppBar";
import {
    getSynchroActiveUser,
    synchronization,
    initSynchronisations,
    getDefaultSyncState,
} from "./redux/synchro/synchroActions";
import { loadInterventionModel } from "./redux/intervention/interventionActions";
import { manageNotificationsPermissions } from "./utils";
import { Component } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment }  from "@mui/x-date-pickers/AdapterMoment";
import { GoogleOAuthProvider } from '@react-oauth/google';

class MyOpenPage extends Component {
    componentDidMount() {
        registerServiceWorker();
        manageNotificationsPermissions();
    }

    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                            <App
                                appBar={
                                    <MenuAppBar
                                        getSynchroActiveUser={getSynchroActiveUser}
                                        synchronization={synchronization}
                                    />
                                }
                                initSynchronisations={initSynchronisations}
                                contextualProps={{
                                    loadInterventionModel: loadInterventionModel,
                                }}
                                getDefaultSyncState={getDefaultSyncState}
                                publicRoutes={publicRoutes}
                                privateRoutes={privateRoutes}
                                testingUserEmail={this.props.testingUserEmail}
                            />
                        </GoogleOAuthProvider>
                    </LocalizationProvider>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default MyOpenPage;
